import { Component, OnInit, OnChanges, SimpleChanges, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-datetime',
  templateUrl: './datetime.component.html',
  styleUrls: ['./datetime.component.css']
})
export class DatetimeComponent implements OnInit, OnChanges {

  @Input() id: string = '';
  @Input() value: string = '';
  @Input() index: string = '';
  @Input() required: boolean = false;

  dateTimeValue: Date | null | undefined = null;
  displayValue: string = '';
  @ViewChild('inputEl') inputEl: ElementRef<HTMLInputElement> | undefined;

  constructor() { }

  ngOnInit() {
    this.parseValue();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value']) {
      this.parseValue();
    }
  }

  private parseValue() {
    const v = this.value;
    if (!v || (typeof v === 'string' && v.trim() === '')) {
      this.dateTimeValue = undefined;
      this.displayValue = '';
      if (this.inputEl && this.inputEl.nativeElement) {
        this.inputEl.nativeElement.value = '';
      }
      return;
    }
    const d = new Date(v);
    this.dateTimeValue = isNaN(d.getTime()) ? undefined : d;
    this.displayValue = this.dateTimeValue ? this.formatDate(this.dateTimeValue) : '';
    if (this.inputEl && this.inputEl.nativeElement) {
      this.inputEl.nativeElement.value = this.displayValue;
    }
  }

  onBsValueChange(newVal: Date | null | undefined) {
    this.dateTimeValue = newVal === undefined ? undefined : newVal;
    this.displayValue = this.dateTimeValue ? this.formatDate(this.dateTimeValue) : '';
    if (this.inputEl && this.inputEl.nativeElement) {
      this.inputEl.nativeElement.value = this.displayValue;
    }
  }

  private formatDate(d: Date): string {
    const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
    const mm = pad(d.getMonth() + 1);
    const dd = pad(d.getDate());
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

}
